import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import messages from './messages';
import style from './style.module.less';

const TableHeader = () => {
  return (
    <div className={style['grid-header']}>
      <div className={style['header-source']}>
        <FormattedMessage {...messages.source} />
      </div>
      <div className={classnames(style['header-item'], style.status)}>
        <FormattedMessage {...messages.status} />
      </div>
      <div className={classnames(style['header-item'], style.status)}>
        <FormattedMessage {...messages.included} />
      </div>
      <div className={style['header-lastUpdated']}>
        <FormattedMessage {...messages.lastUpdated} />
      </div>
      <div className={style['header-item']}>
        <FormattedMessage {...messages.quantity} />
      </div>
    </div>
  );
};

export default TableHeader;
